export default __webpack_public_path__ + "static/media/Liberar_ODC.032c0c25.svg";